/**
 * ERROR STATE
 * Composant réutilisable pour afficher un état d'erreur avec retry
 * Remplace les 18 lignes dupliquées dans chaque page
 */

import { Button } from './button';

interface ErrorStateProps {
  title: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <p className="text-sm text-red-600">{title}</p>
      {message && <p className="text-xs text-zinc-500">{message}</p>}
      {onRetry && <Button onClick={onRetry}>Réessayer</Button>}
    </div>
  );
}
